<template>
  <div style="width:100%;height: 100%;overflow:auto;">
    <div style="display: flex;margin-top: 10px;margin-left: 10px">
      <div style="width: 300px;font-size: 18px "><b>授权方式</b></div>
      <el-select v-model="authorizeTypeCatalog" style="width:150px;" @change="initAuthorizeData">
        <el-option v-for="item in catalogList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="authorizeTypeYear" style="width:150px;margin-left: 10px" @change="initAuthorizeData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: 98%;height: 300px;" id="authorizeTypeChart"> </div>

    <div style="display: flex;margin-top: 10px;margin-left: 10px">
      <div style="width: 300px;font-size: 18px"><b>版本销量(套)</b></div>
      <el-select v-model="versionSalesCompany" style="width:150px;" @change="initVersionSalesData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="versionSalesCatalog" style="width:150px;margin-left: 10px" @change="initVersionSalesData">
        <el-option v-for="item in catalogList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="versionSalesYear" style="width:150px;margin-left: 10px" @change="initVersionSalesData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: 98%;height: 300px;" id="versionSalesChart"> </div>

    <div style="display: flex;margin-top: 10px;margin-left: 10px">
      <div style="width: 300px;font-size: 18px"><b>单机/网络版销量(套)</b></div>
      <el-select v-model="singleNetworkCompany" style="width:150px;" @change="initSingleNetworkData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="singleNetworkCatalog" style="width:150px;margin-left: 10px" @change="initSingleNetworkData">
        <el-option v-for="item in catalogList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="singleNetworkYear" style="width:150px;margin-left: 10px" @change="initSingleNetworkData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: 98%;height: 300px;" id="singleNetworkChart"> </div>



  </div>

</template>

<script>
import * as echarts from "echarts";
import dayjs from "dayjs";

export default {
  name: "ProductData",

  data(){
    return{
      authorizeTypeCatalog:'',
      catalogList:[],
      authorizeTypeYear:'',
      yearList:[],
      companyList:[],
      versionSalesCompany:'summaryData',
      versionSalesCatalog:'',
      versionSalesYear:'',
      singleNetworkCompany:'summaryData',
      singleNetworkCatalog:'',
      singleNetworkYear:'',

      authorizeSeriesData:[],
      versionSalesData:[],
      singleNetworkData:[],


    }
  },
  async created() {
    await this.getYearList();
    await this.getCatalogList();
    await this.getCompanyList();

    await this.initAuthorizeData();
    await this.initVersionSalesData();
    await this.initSingleNetworkData();
  },
  methods:{

    async initAuthorizeData(){
      await this.getAuthorizeTypeData();
      await this.renderEcharts('authorizeTypeChart');
    },

    async getAuthorizeTypeData(){
      let params = {year:this.authorizeTypeYear,catalogId:this.authorizeTypeCatalog};
      let data = await this.$http('crmBusinessService.getAuthorizeTypeData',params);
      if(!data){
        return;
      }
      this.authorizeSeriesData = data;
    },
    async initVersionSalesData(){
      await this.getVersionSalesData();
      await this.renderEcharts('versionSalesChart');
    },

    async getVersionSalesData(){
      let params = {year:this.versionSalesYear,catalogId:this.versionSalesCatalog,company:this.versionSalesCompany};
      let data = await this.$http('crmBusinessService.getVersionSalesDataData',params);
      if(!data){
        return;
      }
      this.versionSalesData = data;
    },

    async initSingleNetworkData(){
      await this.getSingleNetworkData();
      await this.renderEcharts('singleNetworkChart');
    },

    async getSingleNetworkData(){
      let params = {year:this.singleNetworkYear,catalogId:this.singleNetworkCatalog,company:this.singleNetworkCompany};
      let data = await this.$http('crmBusinessService.getSingleNetworkData',params);
      if(!data){
        return;
      }
      this.singleNetworkData = data;
    },

    async getYearList(){
      const now = dayjs();
      this.authorizeTypeYear = now.year() + '';
      this.versionSalesYear = now.year() + '';
      this.singleNetworkYear = now.year() + '';
      this.yearList = await this.$http('sysDsService.getYears(10,1)')
    },
    async getCatalogList(){
      this.catalogList = await this.$http('crmBusinessService.getProductCategory');
      if(this.catalogList.length>0){
        this.authorizeTypeCatalog = this.catalogList[0].id;
        this.versionSalesCatalog = this.catalogList[0].id;
        this.singleNetworkCatalog = this.catalogList[0].id;
      }
    },
    async getCompanyList(){
      let data = await this.$http('crmTeamService.getCompanyList');
      data.unshift({value:'summaryData',label:'汇总数据'})
      this.companyList = data;
    },

    async renderEcharts(type) {
      if(type === 'authorizeTypeChart'){
        const authorizeWayChartDom = document.getElementById('authorizeTypeChart');
        // 获取现有的 ECharts 实例（如果有）
        let authorizeWayChart = echarts.getInstanceByDom(authorizeWayChartDom);
        // 如果存在现有的实例，销毁它
        if (authorizeWayChart) {
          authorizeWayChart.dispose();
        }
        // 初始化新的 ECharts 实例
        authorizeWayChart = echarts.init(authorizeWayChartDom);
        authorizeWayChart.setOption(this.getAuthorizeWayChartOptions(), true);
      }

      if(type === 'versionSalesChart'){
        const versionSalesChartDom = document.getElementById('versionSalesChart');
        // 获取现有的 ECharts 实例（如果有）
        let versionSalesChart = echarts.getInstanceByDom(versionSalesChartDom);
        // 如果存在现有的实例，销毁它
        if (versionSalesChart) {
          versionSalesChart.dispose();
        }
        // 初始化新的 ECharts 实例
        versionSalesChart = echarts.init(versionSalesChartDom);
        versionSalesChart.setOption(this.getVersionSalesChartOptions(), true);
      }
      if(type === 'singleNetworkChart'){
        const singleNetworkChartDom = document.getElementById('singleNetworkChart');
        // 获取现有的 ECharts 实例（如果有）
        let singleNetworkChart = echarts.getInstanceByDom(singleNetworkChartDom);
        // 如果存在现有的实例，销毁它
        if (singleNetworkChart) {
          singleNetworkChart.dispose();
        }
        // 初始化新的 ECharts 实例
        singleNetworkChart = echarts.init(singleNetworkChartDom);
        singleNetworkChart.setOption(this.getSingleNetworkChartOptions(), true);
      }
    },
    getAuthorizeWayChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        yAxis: {
          type: 'category',
          data: ['按季租赁', '按月运维', '软件运维', '软件本体', '本体含运维']
        },
        xAxis: {
          type: 'value'
        },
        series: this.authorizeSeriesData === undefined ? [] : this.authorizeSeriesData
      }
    },
    getVersionSalesChartOptions(){
      return{
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.versionSalesData === undefined ? [] : this.versionSalesData
      }
    },
    getSingleNetworkChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.singleNetworkData === undefined ? [] : this.singleNetworkData
      }
    },

  }
}
</script>

<style scoped>

</style>